import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'CHILD_PROFILE_BASIC_INFO';

export const {action: toggleEditBasicChildInfo} = createAction(`${domain}/TOGGLE_EDIT_BASIC_CHILD_INFO`, edit => ({
    edit,
}));

export const {
    action: saveBasicInfo,
    success: saveBasicInfoSuccess,
    failed: saveBasicInfoFailed,
} = createAction(
    `${domain}/SAVE_BASIC_INFO`,
    (childId, child, keyWorkers, custody, livesWith, kikuChild, autoGeneratedId) => ({
        childId,
        child,
        keyWorkers,
        custody,
        livesWith,
        kikuChild,
        autoGeneratedId,
    }),
);

export const {
    action: fetch,
    success: fetchSuccess,
    failed: fetchFailed,
} = createAction(`${domain}/FETCH_BASIC_INFO`, (childId, withKiku, showAutoGeneratedId) => ({
    childId,
    withKiku,
    showAutoGeneratedId,
}));
